import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 55 64",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.657 36.09c.285 8.914 7.685 16.14 16.525 16.14s16.647-7.348 16.362-16.26c-.032-.99-.688-7.938-4.563-11.938l6.75-6.812c4.064 4.125 8.87 13.995 6.75 24.813-1.812 9.249-10.665 20.187-24.98 20.187-14.313 0-26.292-11.698-26.755-26.13C1.336 23.29 10 11.713 21.982 9.47V2l17.375 10.22-17.25 16.563s-.026-8.028 0-8.72c-7.014 1.676-10.695 8.39-10.45 16.028v-.001z",
      stroke: "#FFF",
      "fill-rule": "nonzero",
      "stroke-width": "2",
      fill: "#86bc4d"
    }, null, -1)
  ])))
}
export default { render: render }